import { useState } from "react";

const reviews = [
  {
    id: 1,
    name: "Joseph M.",
    location: "Los Angeles, CA",
    rating: 5,
    date: "March 2026",
    service: "Tree Removal",
    text: "Absolutely incredible service. They removed a massive 70-foot pine that was dangerously close to my house. The crew was professional, fast, and cleaned up every single branch. Highly recommend!",
    avatar: "https://public.readdy.ai/ai/img_res/9c804a050fb5a35aa306137113f19428.jpg",
    pro: "Complete Tree Services",
  },
  {
    id: 2,
    name: "Fernando P.",
    location: "Simi Valley, CA",
    rating: 5,
    date: "February 2026",
    service: "Tree Trimming",
    text: "Got three quotes through this site and saved over $350 compared to the first company I called on my own. The matched pro showed up on time, did beautiful work on my oak trees, and left the yard spotless.",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latino%20man%20headshot%20professional%20portrait%20warm%20natural%20light%20neutral%20background%2040s&width=80&height=80&seq=rev-002&orientation=squarish",
    pro: "Ari's Treescape Services",
  },
  {
    id: 3,
    name: "Jason M.",
    location: "Fresno, CA",
    rating: 5,
    date: "January 2026",
    service: "Stump Grinding",
    text: "Had two stubborn stumps in my backyard for years. Found Abiel through this site — he came out the next day, ground both stumps down, and filled the holes. Super fair price and great attitude.",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20young%20man%20headshot%20professional%20portrait%20warm%20natural%20light%20neutral%20background%20casual&width=80&height=80&seq=rev-003&orientation=squarish",
    pro: "Abiel and Trees",
  },
];

export default function ReviewsSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="bg-[#1B4332] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block text-green-400 text-xs font-bold uppercase tracking-widest mb-2">
              Verified Reviews
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-white">
              What Homeowners Are Saying
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
              ))}
            </div>
            <span className="text-white font-bold text-sm">4.9</span>
            <span className="text-white/50 text-sm">· 1,200+ reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.map((r, idx) => (
            <div
              key={r.id}
              onClick={() => setActive(idx)}
              className={`rounded-2xl p-6 flex flex-col gap-4 cursor-pointer transition-all duration-200 ${
                active === idx ? "bg-white" : "bg-white/10 hover:bg-white/15"
              }`}
            >
              {/* Stars */}
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`text-sm ${i < r.rating ? "ri-star-fill text-amber-400" : "ri-star-line text-gray-300"}`}></i>
                ))}
              </div>

              <p className={`text-sm leading-relaxed italic ${active === idx ? "text-gray-700" : "text-white/80"}`}>
                &ldquo;{r.text}&rdquo;
              </p>

              <div className={`text-xs font-semibold ${active === idx ? "text-[#1B4332]" : "text-green-400"}`}>
                Pro: {r.pro}
              </div>

              <div className="flex items-center gap-3 pt-3 border-t border-white/10">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={r.avatar} alt={r.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className={`text-sm font-bold ${active === idx ? "text-[#1B4332]" : "text-white"}`}>{r.name}</p>
                  <p className={`text-xs ${active === idx ? "text-gray-400" : "text-white/50"}`}>
                    {r.location} · {r.service} · {r.date}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {reviews.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${active === i ? "bg-green-400 w-6" : "bg-white/30"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
